// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_cbb09b7","container":"_6de7f9c","icon":"_91acb81","menu":"_f854a53"};